<template>
  <page-section
    tag="color-section"
    v-bind="$attrs"
    :background-colors="documentBackgroundColors(product)"
    :text-color="documentTextColor(product)"
    centered
  >
    <div class="container flex flex-wrap items-center text-center md:text-left">
      <header class="w-full md:w-1/2">
        <h3 class="heading">
          {{ product.title }}
        </h3>
        <h4 v-if="product.description" class="heading--sm mb-y-gutter-sm">
          {{ product.description }}
        </h4>
        <cta tag="recess-link" :to="documentPath(product)" fill> Shop </cta>
      </header>
      <div
        v-if="product.thumb?.image"
        class="order-first w-full mb-4em md:mb-0 md:order-none md:w-1/2 md:pl-x-gutter-sm"
      >
        <recess-link :to="documentPath(product)">
          <float
            offset="-2%"
            tag="hero"
            :default-media="product.thumb"
            :title="product.title"
          />
        </recess-link>
      </div>
    </div>
  </page-section>
</template>

<script>
export default {
  name: 'FeaturedProduct',

  props: {
    product: {
      default: null,
      type: Object
    }
  }
}
</script>
